// Utils
import { appendOpacityValueToColour } from '../../../utils/colours';
import { grey, red, green, orange, blue, dash, contact, patient, clinical, financial, report, admin, help, } from '../../colours';
export var baseTheme = {
    typography: {
        fontFamily: 'Arial',
    },
    /**
     * Ezyvet component styles
     */
    disabledGradient: {
        100: grey[50],
        200: grey[100],
        300: grey[200],
        400: grey[300],
        500: grey[400],
    },
    /**
     * Backgrounds & borders
     */
    backgroundUI: grey['0'],
    backgroundPrimary: grey['100'],
    backgroundSecondary: grey['50'],
    backgroundTertiary: grey['200'],
    backgroundAccentPrimary: blue['600'],
    backgroundAccentSecondary: blue['200'],
    backgroundPositive: green['100'],
    backgroundWarning: orange['100'],
    backgroundNegative: red['100'],
    backgroundTransparent: 'transparent',
    backgroundOverlay: appendOpacityValueToColour(grey['900'], 10),
    borderPrimary: grey['300'],
    borderSecondary: grey['400'],
    borderTertiary: grey['600'],
    borderAccent: blue['500'],
    borderNegative: red['800'],
    /**
     * Content
     */
    contentPrimary: grey['900'],
    contentSecondary: grey['800'],
    contentTertiary: grey['700'],
    contentAccessory: grey['500'],
    contentOnColor: grey['0'],
    contentAccent: blue['600'],
    contentAccentOnColor: blue['800'],
    contentPositive: green['800'],
    contentPositiveOnColor: green['900'],
    contentWarning: orange['800'],
    contentWarningOnColor: orange['900'],
    contentNegative: red['800'],
    contentNegativeOnColor: red['900'],
    /**
     * Interactive
     */
    hoverAccent: blue['700'],
    hoverHighlight: blue['50'],
    clickedAccent: blue['800'],
    clickedHighlight: blue['100'],
    hoverOverlayPrimary: appendOpacityValueToColour(grey['900'], 5),
    hoverOverlaySecondary: appendOpacityValueToColour(grey['900'], 10),
    clickedOverlay: appendOpacityValueToColour(grey['900'], 15),
    disabledPrimary: grey['300'],
    disabledSecondary: grey['400'],
    disabledTertiary: grey['500'],
    /**
     * Records
     */
    recordsDashboardPrimary: dash['300'],
    recordsDashboardSecondary: dash['50'],
    recordsContactPrimary: contact['400'],
    recordsContactSecondary: contact['50'],
    recordsPatientPrimary: patient['300'],
    recordsPatientSecondary: patient['50'],
    recordsClinicalPrimary: clinical['500'],
    recordsClinicalSecondary: clinical['50'],
    recordsFinancialPrimary: financial['700'],
    recordsFinancialSecondary: financial['50'],
    recordsReportPrimary: report['300'],
    recordsReportSecondary: report['50'],
    recordsAdminPrimary: admin['300'],
    recordsAdminSecondary: admin['50'],
    recordsHelpPrimary: help['600'],
    recordsHelpSecondary: help['50'],
};
//# sourceMappingURL=baseTheme.js.map